import Vue from 'vue';
import UniButton from './UniButton';
import UhCard from './UhCard';
import UniLoadingView from './UniLoadingView';
import UniImage from './UniImage';
import UhModal from './UhModal';
import UhProgressBar from './UhProgressBar';
import UhAlert from './UhAlert';
import UhShare from './UhShare';

[
  UniButton,
  UhCard,
  UniImage,
  UniLoadingView,
  UhModal,
  UhProgressBar,
  UhAlert,
  UhShare,
].forEach((Component) => {
  Vue.component(Component.name, Component);
});
